import React from 'react';
import styled from 'styled-components';

import { Avatar, Text, theme } from 'components';

type ContactItemLayoutProps = {
  avatarUser: {
    firstName: string;
    lastName: string;
    avatarFilestackId?: string;
  };
  mainText: string;
  subTextOne?: string;
  subTextTwo?: string;
};

const ContactItemLayout: React.FC<ContactItemLayoutProps> = ({
  avatarUser,
  mainText,
  subTextOne,
  subTextTwo,
}) => (
    <StyledLayoutGrid data-cy={`contact-item-${mainText}`}>
      <Avatar user={avatarUser} width={36} />
      <StyledTextContainer data-cy="contact-item-text">
        <StyledMainText strong>{mainText}</StyledMainText>
        <StyledSubTextOne>{subTextOne}</StyledSubTextOne>
        <StyledSubTextTwo>{subTextTwo}</StyledSubTextTwo>
      </StyledTextContainer>
    </StyledLayoutGrid>
  );

export default ContactItemLayout;

const StyledLayoutGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 14px;
`;

const StyledTextContainer = styled.div``;

const StyledMainText = styled(Text)`
  display: block;
`;

const StyledSubTextOne = styled.div`
  font-size: 12px;
  color: ${theme.gray8};
`;

const StyledSubTextTwo = styled.div`
  font-size: 12px;
  color: ${theme.gray8};
`;
